import { useMutation } from '@tanstack/react-query'

import useAppDispatch from '@/hooks/useAppDispatch'
import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import sessionMetadataService from '@/lib/services/sessionService'
import { initialiseSessionSuccess } from '@/redux/slices/session'

export function useRefreshSessionMetadataMutation() {
  const dispatch = useAppDispatch()
  const showGenericServerError = useShowGenericServerError()

  return useMutation({
    mutationFn: async () => {
      const sessionMetadata =
        await sessionMetadataService.createSessionMetadata()

      dispatch(
        initialiseSessionSuccess({
          metadata: sessionMetadata,
        }),
      )
    },
    onError: showGenericServerError,
  })
}
